export type Report = {
    ad: string
    date: string
    clicks: number
    impressions: number
    spend: number
    leads: number
}

export type Summary = Pick<Report, "leads" | "spend" | "impressions" | "clicks">;


export const procedures = ['bi', 'bt', 'pr', 'fs', 'nd', 't'] as const;
export type ProcedureType = typeof procedures[number];

export const ProcedureLabel:Record<ProcedureType, string> = {
    "bi": "Bioestimulação",
    "bt": "Botox",
    "fs": "Fios de Sustentação",
    "pr": "Preenchimento",
    "nd": "Outros",
    "t": "Total"
}

export type ProcedureReport = {
    [key in ProcedureType]?: Summary;
};

export type ProcedureAccount = {
	id: number, name: string, metaId: string
}

export type ProcedureReportEntry = ProcedureAccount & {info: ProcedureReport}

export const props:(keyof Summary)[] = ["leads", "spend" , "impressions", "clicks"] 
export type Prop = typeof props[number]

export const propsLabel = {
    leads: "Leads", 
    spend: "Investimento",
    impressions: "Impressões", 
    clicks: "Clicks"
} as const

export const hidebleProps = ["spend" , "impressions", "clicks"] as const
export type HidebleProp = typeof hidebleProps[number]
